import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTheme } from "../actions/ThemeAction";
import NotificationHandler from "./NotificationHandler";
import { applyThemeColors, applyThemeFonts } from "./ThemeUtils";
import { enumUtil } from "./Enum";
import { ServerRequestProtected } from "./ServerDataRequest";

const THEME_CACHE_KEY = 'themeConfig';

const ThemeProvider = ({ children }) => {
    const dispatch = useDispatch();

    const themeFromRedux = useSelector((state) => state.Theme?.theme);

    const ThemeConfiguration = themeFromRedux || JSON.parse(localStorage.getItem(THEME_CACHE_KEY) || "null");


    useEffect(() => {
        if (ThemeConfiguration) {
            applyThemeColors(ThemeConfiguration?.configuration?.branding?.colors);
            applyThemeFonts(ThemeConfiguration?.configuration?.branding?.fonts);

            if (!themeFromRedux) {
                dispatch(setTheme(ThemeConfiguration));
            }

            return;
        }

        ServerRequestProtected(
            enumUtil.controller.Tenant + "/bootstrap",  "get")
            .then((response) => {
                applyThemeColors(response?.configuration?.branding?.colors);
                applyThemeFonts(response?.configuration?.branding?.fonts);

                dispatch(setTheme(response));

                localStorage.setItem(THEME_CACHE_KEY, JSON.stringify(response));
            })
            .catch((error) => {
                NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
            });

    }, [ThemeConfiguration, themeFromRedux, dispatch]);

    return children;
};

export default ThemeProvider;